import React from 'react'
import PropTypes from 'prop-types'
import { Router } from '@reach/router'

import { Alert } from '../../../components'

const Authorize = props => {
  const authUrl = `/links/client_canvas.authorize_v3/${props.coursenum}/`
  return (
    <div className="maxw-600px mx-auto text-center">
      <Router>
        <Alert
          path="error"
          bootstrapClass="danger"
          message="Authorization failed"
        />
      </Router>
      <h4>Authorization</h4>
      <p>We need your permission to perform the following actions in Canvas:</p>
      <ul className="text-left">
        <li>Create a Course Link for students to access MyEducator directly</li>
        <li>Create Assignments</li>
      </ul>
      <a href={authUrl} className="btn btn-success btn-lg">
        Authorize
      </a>
    </div>
  )
}

Authorize.propTypes = {
  coursenum: PropTypes.string.isRequired,
}

export default Authorize
